export const initWOW = () => {
  if (typeof window !== 'undefined' && window.WOW) {
    new window.WOW().init();
  } else if (typeof window !== 'undefined') {
    // Try to load WOW from CDN or wait for it
    setTimeout(() => {
      if (window.WOW) {
        new window.WOW().init();
      }
    }, 100);
  }
};

export const initParallax = () => {
  if (typeof window !== 'undefined' && window.Parallax) {
    setTimeout(() => {
      const parallaxElements = document.querySelectorAll('.parallax-window, .parallax-window2');
      parallaxElements.forEach((el) => {
        if (window.Parallax) {
          new window.Parallax(el);
        }
      });
    }, 200);
  }
};

